import { render, staticRenderFns } from "./stats-units.vue?vue&type=template&id=2a48b310&scoped=true&"
import script from "./stats-units.vue?vue&type=script&lang=js&"
export * from "./stats-units.vue?vue&type=script&lang=js&"
import style0 from "./stats-units.vue?vue&type=style&index=0&id=2a48b310&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a48b310",
  null
  
)

export default component.exports